var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "workingHours" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("newWizartV2.workingHours"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          {
            class: _vm.mode === "7/24" ? "w-card active" : "w-card",
            attrs: { id: "1" },
            on: {
              click: function ($event) {
                _vm.mode = "7/24"
              },
            },
          },
          [
            _c("div", { staticClass: "full-time" }, [
              _c("div", { staticClass: "icon" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [_c("DynamicSvg", { attrs: { name: "FullTime" } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v("\n                        7 / 24 "),
                _c("br"),
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("newWizartV2.continuousService")) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("newWizartV2.continuousServiceDescription")) +
                    "\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "select-button",
                on: {
                  click: function ($event) {
                    _vm.mode = "7/24"
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("newWizartV2.vote")) +
                    "\n                "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class:
              _vm.mode === "agent-status-based" ? "w-card active" : "w-card",
            attrs: { id: "2" },
            on: {
              click: function ($event) {
                _vm.mode = "agent-status-based"
              },
            },
          },
          [
            _c("div", { staticClass: "option-time" }, [
              _c("div", { staticClass: "icon" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [
                    _c("DynamicSvg", {
                      attrs: { color: "white", name: "ManTime" },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("newWizartV2.representativeWorking")) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.$t("newWizartV2.representativeWorkingDescription")
                    ) +
                    "\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "select-button",
                on: {
                  click: function ($event) {
                    _vm.mode = "agent-status-based"
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("newWizartV2.vote")) +
                    "\n                "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: _vm.mode === "custom" ? "w-card active" : "w-card",
            attrs: { id: "3" },
            on: {
              click: function ($event) {
                _vm.mode = "custom"
              },
            },
          },
          [
            _c("div", { staticClass: "private-time" }, [
              _c("div", { staticClass: "icon" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [
                    _c("md-icon", { staticStyle: { color: "white" } }, [
                      _vm._v("update"),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("fastWizard.customHours"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "inputs-wrapper" },
                [
                  _c("div", { staticClass: "local-time" }, [
                    _c(
                      "div",
                      [
                        _c("span", { staticStyle: { display: "flex" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("fastWizard.customHoursTimezone"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select",
                          {
                            attrs: {
                              "show-search": "",
                              placeholder: _vm.$t(
                                "fastWizard.placeholderSelectTimezone"
                              ),
                              "option-filter-prop": "children",
                              "filter-option": _vm.filterOption,
                              value: _vm.timezone,
                            },
                            on: { change: _vm.changeTimezone },
                          },
                          _vm._l(_vm.timezones, function (tz, i) {
                            return _c(
                              "a-select-option",
                              { key: i, attrs: { value: tz } },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(tz) +
                                    "\n                                    "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.rules, function (rule) {
                    return _c("div", { staticClass: "ruleItem" }, [
                      _c("div", { staticClass: "options" }, [
                        _c(
                          "div",
                          { staticClass: "days" },
                          [
                            _c("span", { staticClass: "display-flex" }, [
                              _vm._v(
                                _vm._s(_vm.$t("message.selectDays")) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                attrs: {
                                  "show-search": "",
                                  placeholder: _vm.$t(
                                    "fastWizard.placeholderSelectDays"
                                  ),
                                  "option-filter-prop": "children",
                                  "filter-option": _vm.filterOption,
                                  value: _vm.daysHashcode(rule.days),
                                },
                                on: {
                                  change: function (e) {
                                    return _vm.handleDayChange(e, rule._id)
                                  },
                                },
                              },
                              _vm._l(_vm.days, function (day, i) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: i,
                                    attrs: {
                                      value: _vm.daysHashcode(day.value),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(day.label[_vm.$i18n.locale]) +
                                        "\n                                        "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "option" },
                          [
                            _c("span", { staticClass: "display-flex" }, [
                              _vm._v(
                                _vm._s(_vm.$t("fastWizard.customHoursFrom"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                attrs: {
                                  "show-search": "",
                                  placeholder: _vm.$t(
                                    "fastWizard.placeholderSelectStartHour"
                                  ),
                                  "option-filter-prop": "children",
                                  "filter-option": _vm.filterOption,
                                  value: rule.from,
                                },
                                on: {
                                  change: function (e) {
                                    return _vm.handleFromHourChange(e, rule._id)
                                  },
                                },
                              },
                              _vm._l(_vm.hours, function (hour, i) {
                                return _c(
                                  "a-select-option",
                                  { key: i, attrs: { value: hour } },
                                  [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(hour) +
                                        "\n                                        "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "option" },
                          [
                            _c("span", { staticClass: "display-flex" }, [
                              _vm._v(
                                _vm._s(_vm.$t("fastWizard.customHoursTo"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                attrs: {
                                  "show-search": "",
                                  placeholder: _vm.$t(
                                    "fastWizard.placeholderSelectEndHour"
                                  ),
                                  "option-filter-prop": "children",
                                  "filter-option": _vm.filterOption,
                                  value: rule.to,
                                },
                                on: {
                                  change: function (e) {
                                    return _vm.handleEndHourChange(e, rule._id)
                                  },
                                },
                              },
                              _vm._l(_vm.hours, function (hour, i) {
                                return _c(
                                  "a-select-option",
                                  { key: i, attrs: { value: hour } },
                                  [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(hour) +
                                        "\n                                        "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.rules.length > 1
                          ? _c(
                              "div",
                              {
                                staticClass: "delete-button",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteHour(rule._id)
                                  },
                                },
                              },
                              [_c("md-icon", [_vm._v(" delete ")])],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "add-hour-button",
                      on: { click: _vm.addHour },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.addTime")))]
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "select-button",
                on: {
                  click: function ($event) {
                    _vm.mode = "custom"
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("newWizartV2.vote")) +
                    "\n                "
                ),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }